module.exports = __webpack_public_path__ + "assets/a1f06cb236a1b94717d872ac94fe3ce8.svg";